import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Images/sm-logo.png';
import { TiThMenu } from "react-icons/ti";
import { FaUser, FaHome } from "react-icons/fa";
import { FaWallet } from "react-icons/fa6";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";

type SidebarProps = {
  closemenu: React.ReactNode;
  showClose: boolean;
  onClose: () => void;
};
const Sidebar: React.FC<SidebarProps> = ({ closemenu, showClose, onClose }) =>{
    const location = useLocation();
    const isAdmin = location.pathname.startsWith('/admin');
    const isAgent = location.pathname.startsWith('/agent');
    const basePath = isAdmin ? '/admin' : '/agent';

    const [ProfileDrop, setProfileDrop] = useState(false);
    const [agentDrop, setagentDrop] = useState(false);
    const [WallethistoryDrop, setWallethistoryDrop] = useState(false);

    return (
        <div className='h-screen overflow-y-auto bg-[#2A3650]'>
            {/* <div className='flex justify-between p-[20px] w-full mb-[50px]'>
                <img className='w-[60%] h-[60%] object-cover' src={logo} alt="Logo" />
                <div className='p-2 bg-[#374462] h-[40px] rounded-lg'>
                    <TiThMenu className='text-white text-[24px] cursor-pointer transition-transform duration-500 hover:rotate-180' />
                    {closemenu}
                </div>
            </div> */}

            <div className='flex justify-between p-[20px] w-full mb-[50px]'>
                <img className='w-[60%] h-[60%] object-cover' src={logo} alt="Logo" />
                <div className='flex items-center gap-2'>
                    <div className='p-2 bg-[#374462] h-[40px] rounded-lg lg:block hidden'>
                         <TiThMenu className='text-white text-[24px] cursor-pointer transition-transform duration-500 hover:rotate-180' />
                    </div>
                    <div className='p-2 bg-[#374462] h-[40px] rounded-lg lg:hidden block'>
                        {closemenu}
                    </div>
                </div>
            </div>
            <div className='px-[20px]'>
                <div className='bg-[#374462] rounded-lg w-fit py-[3px] px-[8px] flex justify-center items-center'>
                    <h4 className='text-white font-[600] m-0'>PINNED</h4>
                </div>
            </div>

            <div className='py-4 w-full'>
                {/* Profile Dropdown */}
                <p
  onClick={() => {
    setProfileDrop(!ProfileDrop);
    setagentDrop(false);
    setWallethistoryDrop(false);
  }}
  className="text-white w-full py-2 hover:bg-[#374462] cursor-pointer font-semibold flex justify-between items-center gap-3 my-4 px-[20px]"
>
  <span className="flex items-center gap-4">
    <FaUser /> Profile
  </span>
  {ProfileDrop ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
</p>

                {ProfileDrop && (
                    <div className="flex flex-col gap-4 pr-5 ml-8 border-l-[1px] border-l-[#cbd5e1]">
                        <div className='flex'>
                            <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                            <Link to={`${basePath}/profile`} className="text-white font-semibold ml-3">Update Profile</Link>
                        </div>
                        <div className='flex'>
                            <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                            <Link to={`${basePath}/passwordchange`} className="text-white font-semibold ml-3">Password Change</Link>
                        </div>
                    </div>
                )}

                {/* Dashboard */}
                <Link to={`${basePath}`} className='text-white font-semibold flex items-center gap-3 my-4 px-[20px]'>
                    <FaHome /> Dashboard
                </Link>

                {/* Agent Section - Admin Only */}
                {isAdmin && (
                    <>
                        <p
  onClick={() => {
    setagentDrop(!agentDrop);
    setWallethistoryDrop(false);
    setProfileDrop(false);
  }}
  className="text-white py-2 hover:bg-[#374462] cursor-pointer font-semibold flex justify-between items-center gap-3 my-4 px-[20px]"
>
  <span className="flex items-center gap-4">
    <FaUser /> Agent
  </span>
  {agentDrop ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
</p>

                        {agentDrop && (
                            <div className="flex flex-col gap-4 pr-5 ml-8 border-l-[1px] border-l-[#cbd5e1]">
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/agent`} className='text-white font-semibold ml-3'>Agent</Link>
                                </div>
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/addagent`} className='text-white font-semibold ml-3'>Add Agent</Link>
                                </div>
                            </div>
                        )}
                       <p
  onClick={() => {
    setWallethistoryDrop(!WallethistoryDrop);
    setProfileDrop(false);
    setagentDrop(false);
  }}
  className="text-white py-2 hover:bg-[#374462] cursor-pointer font-semibold flex justify-between items-center gap-3 my-4 px-[20px]"
>
  <span className="flex items-center gap-4">
    <FaWallet /> Wallet History
  </span>
  {WallethistoryDrop ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
</p>

                        {WallethistoryDrop && (
                            <div className="flex flex-col gap-4 pr-5 ml-8 border-l-[1px] border-l-[#cbd5e1]">
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/pending-payment`} className='text-white font-semibold ml-3'>Verify Payment Credit</Link>
                                </div>
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/wallethistory`} className='text-white font-semibold ml-3'>Wallet History</Link>
                                </div>
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/verfywallethistoryall`} className='text-white font-semibold ml-3'>Verify Payment Debit</Link>
                                </div>
                            </div>
                        )}
                    </>
                )}

                {/* Wallet History */}

                {isAgent &&
                    <>
                        <p className='text-white py-2 hover:bg-[#374462] cursor-pointer font-semibold flex justify-between items-center gap-3 my-4 px-[20px]'>
                            <span className='flex items-center gap-4'><FaWallet /> Wallet History</span>
                            {WallethistoryDrop ? (
                                <MdKeyboardArrowDown onClick={() => {
                                    setWallethistoryDrop(!WallethistoryDrop);
                                    setProfileDrop(false);
                                    setagentDrop(false);
                                }} />
                            ) : (
                                <MdKeyboardArrowRight onClick={() => {
                                    setWallethistoryDrop(!WallethistoryDrop);
                                    setProfileDrop(false);
                                    setagentDrop(false);
                                }} />
                            )}
                        </p>
                        {WallethistoryDrop && (
                            <div className="flex flex-col gap-4 pr-5 ml-8 border-l-[1px] border-l-[#cbd5e1]">

                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/wallethistory`} className='text-white font-semibold ml-3'>Wallet History</Link>
                                </div>
                                <div className='flex'>
                                    <div className='bg-[#cbd5e1] h-[1px] w-[20px] mt-3' />
                                    <Link to={`${basePath}/verfywallethistoryall`} className='text-white font-semibold ml-3'>Verify Payment Debit</Link>
                                </div>
                            </div>
                        )}
                    </>
                }


                {/* Customers */}
                <Link to={`${basePath}/customers`} className='text-white font-semibold flex items-center gap-3 my-4 px-[20px]'>
                    <FaUser /> Customers
                </Link>
            </div>
        </div>
    );
}

export default Sidebar;
